<template>
  <tr>
    <td>
      <b>{{ typeText }}</b>
    </td>
    <td>
      <template v-if="isAuditorEditable">
        <b-select
          v-if="users.length"
          v-model="user"
          placeholder="Auditor wählen"
        >
          <option
            v-for="u in users"
            :value="u"
            :key="u.sub"
          >
            {{ u.givenName }} {{ u.familyName }}
          </option>
        </b-select>
      </template>
      <template v-else>
        <span>{{ userText(row) }}</span>
      </template>
    </td>
  </tr>
</template>

<script>

import AuditService from '@/services/audits.service'

export default {
  name: 'AuditorList',
  props: {
    row: {
      required: true,
      type: Object
    },
    users: {
      required: true,
      type: Array
    },
    isAuditorEditable: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      updating: false
    }
  },
  computed: {
    typeText () {
      let txt = ''
      switch (this.row.cat) {
        case 'S':
          txt = `Selbstevaluation ${this.row.year}`
          break
        case 'A':
          txt = `Audit ${this.row.year}`
          break
        case 'C':
          txt = `Coaching ${this.row.year}`
          break
      }
      return txt
    },
    user: {
      get () {
        return this.row ? this.row.auditor : null
      },
      set (user) {
        if (this.row) {
          this.updateAudit(user)
        }
      }
    }
  },
  methods: {
    async updateAudit (user) {
      this.updating = true
      try {
        await AuditService.changeAuditorOfRunningSelfEval(this.row.id, user.sub)
        this.$emit('updated')
        this.$emit('close')
        this.$buefy.toast.open({
          message: `${this.typeText} wurden angepasst`,
          type: 'is-success'
        })
        this.row.auditor = user
      } catch (error) {
        this.$buefy.toast.open({
          message: `${this.typeText} konnte nicht angepasst werden`,
          type: 'is-danger'
        })
      }
      this.updating = false
    },
    userText (row) {
      let txt = ''
      if ((row) && (row.auditor)) {
        txt = `${row.auditor.givenName} ${row.auditor.familyName}`
      }
      return txt
    }
  }
}
</script>
